import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default () => {}

/* eslint-disable prettier/prettier */

export function DmcGrid({ columns = [], columnGap = 10, rowGap = 10, children }) {
  const columnsStr = `${columns.map((number) => {
    return `minmax(0, ${number}fr) `
  }).join('')}`
  const gridCss = css`
    display: grid;
    grid-template-columns: ${columnsStr};
    grid-row-gap: ${rowGap}px;
    grid-column-gap: ${columnGap}px;
    align-items: center;
  `
  return <div css={gridCss}>{children}</div>
}

export function DmcGridSeparator() {
  const SeparatorCss = css`
    border-top: 1px solid ${colors.gray20};
    grid-column: 1/-1;
  `
  return <div css={SeparatorCss} />
}

/* eslint-enable prettier/prettier */
